/**
 * @voltxampere/ui — 7-segment common-cathode display variant (Sprint 43-7, placeholder)
 *
 * PLACEHOLDER. Single-digit common-cathode 7-segment LED display
 * (5161AS-class). The variant ships as an idealized voltage-source
 * placeholder — visual segment rendering and per-segment LED
 * simulation arrive Sprint 47+ along with display full-simulation.
 *
 * Reference: Generic 5161AS / 5611AS class CC display. 7 anode pins +
 * 1 cathode pin + 1 decimal-point pin.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const display7segCc = {
    id: "7seg-cc",
    nameTr: "7 Segment Display (Ortak Katot, 5161AS, placeholder)",
    nameEn: "7-Segment Display (Common Cathode, 5161AS, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "DS",
    defaultValue: "7SEG-CC",
    schemaType: "voltage-source",
    defaultParams: { voltage: 0 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=display-7seg-cc.js.map